var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"header"}}),_c('main',{class:{'main':_vm.$route.name !== 'Register' && _vm.$route.name !== 'Login' && _vm.$route.name !== 'Reset Password' && _vm.$route.name !== 'New Password'}},[_c('router-view',{attrs:{"name":"navigation"}}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }